module.exports = __webpack_public_path__ + "media/images/1920/annie-spratt-7MX4Clmx-K0-unsplash-df6ad5494d138d805f8bcfc5e99c561d.webp";